import {
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  dashBoardData: {},
};

const getDashboardDataReducer = (state = INIT_STATE, action) => {
  switch (action?.type) {
    case GET_DASHBOARD_DATA:
      return { ...state, loading: true };
    case GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        dashBoardData: action?.payload,
        loading: false,
      };
    case GET_DASHBOARD_DATA_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default getDashboardDataReducer;